import Table from 'react-bootstrap/Table';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import Form from 'react-bootstrap/Form';
import { Pencil, Trash } from "react-bootstrap-icons";
import * as client from '../api/client';
import { useState, useEffect } from 'react';

const currentLang = "ru";

const roleLabels = {
    ADMIN: { en: "Administrator", ru: "Администратор" },
    MAINTAINER: { en: "Manager", ru: "Менеджер" },
    FLORIST: { en: "Florist", ru: "Флорист" }
};

function EmployeeTable() {
    const [users, setUsers] = useState([]);
    const [allRoles, setAllRoles] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const [editingUser, setEditingUser] = useState(null);
    const [editName, setEditName] = useState("");
    const [editRoles, setEditRoles] = useState([]);
    const [showModal, setShowModal] = useState(false);

    useEffect(() => {
        let cancelled = false;

        (async () => {
            try {
                const [userData, roleData] = await Promise.all([
                    client.getAllUsers(),
                    client.getAllRoles()
                ]);
                if (!cancelled) {
                    setUsers(userData);
                    setAllRoles(roleData);
                    setLoading(false);
                }
            } catch (err) {
                if (!cancelled) {
                    setError(err.message);
                    setLoading(false);
                }
            }
        })();

        return () => {
            cancelled = true;
        };
    }, []);

    const handleDelete = async (id) => {
        if (window.confirm("Удалить этого сотрудника?")) {
            await client.deleteUserById(id);
            const data = await client.getAllUsers();
            setUsers(data);
        }
    };

    const handleEdit = (user) => {
        setEditingUser(user);
        setEditName(user.name);
        setEditRoles(user.roles);
        setShowModal(true);
    };

    const handleSave = async () => {
        if (editingUser) {
            const updated = { ...editingUser, name: editName, roles: editRoles };
            await client.updateUser(updated);
            setUsers(users.map(u => u.id === editingUser.id ? updated : u));
        } else {
            const newUser = { name: editName, roles: editRoles };
            const created = await client.createUser(newUser);
            setUsers([...users, created]);
        }
        setShowModal(false);
    };

    if (loading) return <p>Загрузка…</p>;
    if (error) return <p>Ошибка: {error}</p>;

    return (
        <div className="container mt-4">
            <Table striped bordered hover responsive>
                <thead>
                    <tr>
                        <th>Сотрудник</th>
                        <th>Роли</th>
                        <th>Действия</th>
                    </tr>
                </thead>
                <tbody>
                    {users.map(user => (
                        <tr key={user.id}>
                            <td>{user.name}</td>
                            <td>{user.roles.map(r => roleLabels[r.name][currentLang]).join(", ")}</td>
                            <td>
                                <Button
                                    variant="outline-primary"
                                    size="sm"
                                    onClick={() => handleEdit(user)}
                                    className="me-2"
                                >
                                    <Pencil size={16} />
                                </Button>
                                <Button
                                    variant="outline-danger"
                                    size="sm"
                                    onClick={() => handleDelete(user.id)}
                                >
                                    <Trash size={16} />
                                </Button>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </Table>
            <Button
                variant="success"
                className="mb-3"
                onClick={() => {
                    setEditingUser(null);
                    setEditName("");
                    setEditRoles([]);
                    setShowModal(true);
                }}
            >
                + Новый сотрудник
            </Button>
            <Modal show={showModal} onHide={() => setShowModal(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>
                        {editingUser ? "Редактировать сотрудника" : "Создать сотрудника"}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <Form.Group className="mb-3">
                            <Form.Label>Имя</Form.Label>
                            <Form.Control
                                type="text"
                                value={editName}
                                onChange={(e) => setEditName(e.target.value)}
                            />
                        </Form.Group>
                        <Form.Group>
                            <Form.Label>Роли</Form.Label>
                            {allRoles.map(role => (
                                <Form.Check
                                    key={role.id}
                                    type="checkbox"
                                    label={roleLabels[role.name]?.[currentLang] || role.name}
                                    checked={editRoles.some(r => r.id === role.id)}
                                    onChange={(e) => {
                                        if (e.target.checked) {
                                            setEditRoles([...editRoles, role]);
                                        } else {
                                            setEditRoles(editRoles.filter(r => r.id !== role.id));
                                        }
                                    }}
                                />
                            ))}
                        </Form.Group>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowModal(false)}>
                        Отмена
                    </Button>
                    <Button variant="primary" onClick={handleSave}>
                        {"Сохранить"}
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
}

export default EmployeeTable;
